import axios from 'axios';
import { req } from './axiosFun';

// 棋牌订单
export const qpOrderList = (params) => { return req("post", "/api/saas/xht/order/qpOrderList", params) };
export const qpRefund = (params) => { return req("post", "/api/saas/xht/order/qpRefund", params) };

// 台球订单
export const tqOrderList = (params) => { return req("post", "/api/saas/xht/order/tqOrderList", params) };
export const tqRefund = (params) => { return req("post", "/api/saas/xht/order/tqRefund", params) };

// 充值订单
export const chargeOrderList = (params) => { return req("post", "/api/saas/xht/order/chargeOrderList", params) };
export const chargeRefund = (params) => { return req("post", "/api/saas/xht/order/chargeRefund", params) };

// 团购订单
export const tuanOrderList = (params) => { return req("post", "/api/saas/xht/order/tuanOrderList", params) };
export const tuanRefund = (params) => { return req("post", "/api/saas/xht/order/tuanRefund", params) };


// WEBPACK FOOTER //
// ./src/api/order.js